import { createContext } from 'react';

export type BehaviourContextType = {
  toggleChat: (params?: { isOpenChat?: boolean }) => void;
};

export const BehaviourContext = createContext<BehaviourContextType>({} as BehaviourContextType);

BehaviourContext.displayName = 'BehaviourContext';
